/**
 * Centralized Environment Configuration
 * Manages all API endpoints, environment detection, and configuration values
 */

// Environment detection utility
const getEnvironment = () => {
  const isLocal = window.location.hostname === 'localhost' || 
                  window.location.hostname === '127.0.0.1' || 
                  process.env.NODE_ENV === 'development';
  
  return isLocal ? 'development' : 'production';
};

const environment = getEnvironment();

// API Configuration
export const apiConfig = {
  environment,
  
  // Search API (TypeScript API - ts-api-container)
  search: {
    development: process.env.REACT_APP_SEARCH_API_URL || 'http://64.225.20.106:8080',
    production: '/api'
  },
  
  // Analytics API (Flask Backend - lw-backend-container)
  analytics: {
    development: process.env.REACT_APP_USE_LOCAL_BACKEND === 'true' 
      ? 'http://localhost:8008/api'
      : (process.env.REACT_APP_ANALYTICS_API_URL || 'http://64.225.20.106:8008/api'),
    production: '/backend'
  },
  
  // User API (tai-khoan service)
  user: {
    development: process.env.REACT_APP_USER_API_URL || 'http://64.225.20.106:8081',
    production: '/tai-khoan'
  }
};

// Auth0 Configuration
export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || 'dev-2iuy3iqe0fejo5wl.us.auth0.com',
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE || 'https://dev-2iuy3iqe0fejo5wl.us.auth0.com/api/v2/'
};

// Application Constants
export const appConfig = {
  name: 'LotWizard',
  version: process.env.REACT_APP_VERSION || '1.0.0',
  
  // Timeouts
  timeouts: {
    api: 30000,          // 30 seconds
    connectivity: 15000,  // 15 seconds (increased for busy server)
    retry: 3000          // 3 seconds
  },
  
  // Retry configuration
  retry: {
    attempts: 3,
    backoff: 1000  // 1 second base backoff
  },
  
  // Rate limiting
  rateLimit: {
    basic: 100,      // requests per day
    standard: 1000,
    premium: 10000,
    admin: Infinity
  }
};

// Helper functions
export const getApiUrl = (service) => {
  const config = apiConfig[service];
  if (!config) {
    throw new Error(`Unknown API service: ${service}`);
  }
  return config[environment];
};

export const isProduction = () => environment === 'production';
export const isDevelopment = () => environment === 'development';

// Debug logging
if (isDevelopment()) {
  console.log('[Config] Environment configuration loaded:', {
    environment,
    apis: {
      search: getApiUrl('search'),
      analytics: getApiUrl('analytics'),
      user: getApiUrl('user')
    },
    auth0: auth0Config
  });
}

export default {
  apiConfig,
  auth0Config,
  appConfig,
  getApiUrl,
  isProduction,
  isDevelopment
};